/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIRole } from '@/models/api/role.model'

const resource = {
    main: 'services',
    module: 'roles'
}

export class RolesServices {
    public static getRoles () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getRolesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getRolesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createRoles (params: APIRole) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editRoles (params: APIRole) {
        return service.put(`${resource.main}/${resource.module}/${params.roleId}`, params)
    }

    public static deleteRoles (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static addPermissionToRole (roleId: number, permissions: number[]) {
        return service.post(`${resource.main}/${resource.module}/add-permissions`, { roleId, permissions })
    }

    public static removePermissionToRole (roleId: number, permissions: number[]) {
        return service.put(`${resource.main}/${resource.module}/delete-permissions`, { roleId, permissions })
    }
}
